// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"1d48ca28","282":"9778b3dc","506":"755a77d6","596":"755a77d6","710":"f673ac59","868":"457a8eec"}[chunkId] + ".chunk.css";
};